/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './post-op-recovery-discharge.reducer';

export const PostOpRecoveryDischarge = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const postOpRecoveryDischargeList = useAppSelector(state => state.postOpRecoveryDischarge.entities);
  const loading = useAppSelector(state => state.postOpRecoveryDischarge.loading);
  const totalItems = useAppSelector(state => state.postOpRecoveryDischarge.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="post-op-recovery-discharge-heading" data-cy="PostOpRecoveryDischargeHeading">
        <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.home.title">Post Op Recovery Discharges</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/post-op-recovery-discharge/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.home.createLabel">
              Create new Post Op Recovery Discharge
            </Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.postOpRecoveryDischarge.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {postOpRecoveryDischargeList && postOpRecoveryDischargeList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('vitalsStable')}>
                  <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.vitalsStable">Vitals Stable</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('vitalsStable')} />
                </th>
                <th className="hand" onClick={sort('patientAbleToWalk')}>
                  <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.patientAbleToWalk">Patient Able To Walk</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('patientAbleToWalk')} />
                </th>
                <th className="hand" onClick={sort('vomiting')}>
                  <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.vomiting">Vomiting</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('vomiting')} />
                </th>
                <th className="hand" onClick={sort('bleeding')}>
                  <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.bleeding">Bleeding</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bleeding')} />
                </th>
                <th className="hand" onClick={sort('pain')}>
                  <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.pain">Pain</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('pain')} />
                </th>
                <th className="hand" onClick={sort('conditionAtDischarge')}>
                  <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.conditionAtDischarge">Condition At Discharge</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('conditionAtDischarge')} />
                </th>
                <th className="hand" onClick={sort('dischargeCriteria')}>
                  <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.dischargeCriteria">Discharge Criteria</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dischargeCriteria')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.surgery">Surgery</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.recoveryDoctor">Recovery Doctor</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {postOpRecoveryDischargeList.map((postOpRecoveryDischarge, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/post-op-recovery-discharge/${postOpRecoveryDischarge.id}`} color="link" size="sm">
                      {postOpRecoveryDischarge.id}
                    </Button>
                  </td>
                  <td>{postOpRecoveryDischarge.vitalsStable ? 'true' : 'false'}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PatientAbleToWalk.${postOpRecoveryDischarge.patientAbleToWalk}`} />
                  </td>
                  <td>{postOpRecoveryDischarge.vomiting ? 'true' : 'false'}</td>
                  <td>{postOpRecoveryDischarge.bleeding ? 'true' : 'false'}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.Pain.${postOpRecoveryDischarge.pain}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PatientCondition.${postOpRecoveryDischarge.conditionAtDischarge}`} />
                  </td>
                  <td>{postOpRecoveryDischarge.dischargeCriteria ? 'true' : 'false'}</td>
                  <td>{postOpRecoveryDischarge.active ? 'true' : 'false'}</td>
                  <td>{postOpRecoveryDischarge.cursor}</td>
                  <td>{postOpRecoveryDischarge.lastupdated}</td>
                  <td>{postOpRecoveryDischarge.microSec}</td>
                  <td>{postOpRecoveryDischarge.timestampentry}</td>
                  <td>
                    {postOpRecoveryDischarge.surgery ? (
                      <Link to={`/patient-procedure/${postOpRecoveryDischarge.surgery.id}`}>{postOpRecoveryDischarge.surgery.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {postOpRecoveryDischarge.recoveryDoctor ? (
                      <Link to={`/doctor/${postOpRecoveryDischarge.recoveryDoctor.id}`}>{postOpRecoveryDischarge.recoveryDoctor.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/post-op-recovery-discharge/${postOpRecoveryDischarge.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/post-op-recovery-discharge/${postOpRecoveryDischarge.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/post-op-recovery-discharge/${postOpRecoveryDischarge.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.postOpRecoveryDischarge.home.notFound">
                No Post Op Recovery Discharges found
              </Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={postOpRecoveryDischargeList && postOpRecoveryDischargeList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PostOpRecoveryDischarge;
